export const GET_DEDUCTION_CALCULATOR_DETAILS = "GET_DEDUCTION_CALCULATOR_DETAILS";
export const GET_SESSION_FEES_CALCULATOR_DETAILS = "GET_SESSION_FEES_CALCULATOR_DETAILS";
